import { AppAlertEventBus } from "@/app/shared/services/app-alert/app-alert";

const appContentEventBus = new AppAlertEventBus();
export default appContentEventBus;
